<template>
  <div>
    <accordion>
        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5 data-qa="aboutStripeTitle">{{ $t('faqstripe1') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <p data-qa="aboutStripeText" class="textAccordion">{{ $t('faqstripe1a') }} <br/> {{ $t('faqstripe1b') }}</p>
            <a href="https://stripe.com/en-si" target="_blank"><img style="width: 150px; margin-left:0;" src="../../assets/static/images/logo/stripe_logo.jpg"></a>
			<br/>
          </template>
        </accordion-item>

        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5 data-qa="setupStripeAccountTitle">{{ $t('faqstripe2') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <br/>
            <p data-qa="setupStripeAccountText" class="textAccordion">{{ $t('faqstripe2a') }} <strong>{{ $t('faqstripe2a1') }}</strong>.</p>
            <br/>
            <br/>
            <div class="resp-container">
                <iframe 
                    class="resp-iframe" 
                    src="https://www.youtube.com/embed/ST7BsUeQjvY" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen
					data-qa="setupStripeAccountVideoBlock">
				</iframe>
            </div>
          </template>
        </accordion-item>

        <accordion-item>
          <!-- This slot will handle the title/header of the accordion and is the part you click on -->
          <template slot="accordion-trigger">
            <h5 data-qa="stripeApiKeysTitle">{{ $t('faqstripe3') }}</h5>
          </template>
          <!-- This slot will handle all the content that is passed to the accordion -->
          <template slot="accordion-content">
            <br/>
            <p data-qa="stripeApiKeysText" class="textAccordion">{{ $t('faqstripe3a') }}</p>
            <br/>
            <br/>
            <div class="resp-container">
                <iframe 
                    class="resp-iframe" 
                    src="https://www.youtube.com/embed/byectV_Ri6c" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen
					data-qa="stripeApiKeysVideoBlock">
				</iframe>
            </div>
          </template>
        </accordion-item>
      </accordion>
  </div>
</template>

<script>
import Accordion from "@/components/common/accordion";
import AccordionItem from "@/components/common/accordion-item";

export default {
  components: {
    Accordion,
    AccordionItem
  }
};
</script>

<style lang="scss" scoped>
.resp-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  // max-width: 400px;
  // max-height: 100px;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.responsive {
  width: 100%;
  height: auto;
}
.stripeLogo {
    max-width: 250px;
  }

.textAccordion {
  text-align: justify;
  font-size: 0.75em;
}
  @media screen and (max-width: 500px) {
h5 {
    font-size: 0.8rem;
    text-align: left;
    }
.textAccordion {
  margin-bottom: 0;
}
  }
</style>
